// Shared formatting helpers.
export const formatCurrency = (amount, currencyCode = 'usd') => {
    const n = typeof amount === 'number' ? amount : parseFloat(amount);
    if (isNaN(n)) return '--';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency', currency: (currencyCode || 'usd').toUpperCase(),
        }).format(n);
    } catch (e) {
        return `$${n.toFixed(2)}`;
    }
};

export const formatDate = (dateString) => {
    if (!dateString) return '--';
    try {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric',
        });
    } catch (e) {
        return dateString;
    }
};

export const formatDateTime = (dateString) => {
    if (!dateString) return '--';
    try {
        return new Date(dateString).toLocaleString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric',
            hour: '2-digit', minute: '2-digit',
        });
    } catch (e) {
        return dateString;
    }
};

export const titleCase = (s) => (s || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
